<template>
	<v-modal>
		<template v-slot:header>
			<h1>Update Fact Find</h1>
		</template>
		<the-fact-find-response-form
			v-if="form"
			:data="lead.factFindResponse.data"
			:fields-only="true"
			:form="form"
			:service="lead.service"
			:structure="lead.factFindResponse.structure"
			@changed="changed"
			@submit="submit"/>
		<template v-slot:footer>
			<ul class="actions">
				<li>
					<button
						:disabled="form.processing" class="button button--secondary"
						v-html="form.isDirty ? 'Cancel' : 'Close'" @click.prevent="$vmodal.close()"/>
				</li>
				<li>
					<process-button
						:processing="form.processing" class="button button--primary" text="Save"
						@click="submit"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import TheFactFindResponseForm from "../../../fact-find/forms/TheFactFindResponseForm.vue";

export default {
	components: {
		TheFactFindResponseForm,
	},

	data() {
		return {
			form: null,
		};
	},

	props: {
		lead: {
			required: true,
			type: Object,
		},
	},

	methods: {
		changed() {
			console.log("EditFactFind.changed");
		},
		submit() {
			this.form.patch(this.route("leads/:lead/fact-find", this.lead)).then(response => {
				this.$store.commit("clients/LEAD_UPDATED", response.data);
			});
		},
	},

	created() {
		this.form = this.newForm(this.lead.factFindResponse.data || {});
		// this.form.prefill(this.lead.factFindResponse.data || {});
	},
};
</script>
